<div
  class="proof"
  tabindex="0"
  [attr.aria-labelledby]="'title-proof-' + proofData.id"
>
  <h5 class="proof__title" [attr.id]="'title-proof-' + proofData.id">
    {{
      proofData.templates1?.length || proofData.templates2?.length
        ? "Folgende Nachweise werden für den Kreditabschluss benötigt"
        : "Es werden keine Nachweisdokumente benötigt"
    }}
  </h5>
  <div
    class="list-wrapper"
    *ngIf="proofData.templates1?.length || proofData.templates2?.length"
  >
    <div
      class="proof_list_wrapper"
      [ngClass]="{
        'proof_list_wrapper-one-applicant': !proofData.twoApplicants,
      }"
      tabindex="0"
      [attr.aria-labelledby]="
        'applicant1-title-' +
        proofData.id +
        (proofData.twoApplicants ? '' : ' title-proof-' + proofData.id)
      "
      #focusableContent
    >
      <p
        *ngIf="proofData.twoApplicants"
        class="proof_list-applicant"
        [attr.id]="'applicant1-title-' + proofData.id"
      >
        {{ proofData.applicant1FullName }}
      </p>
      <ul
        class="proof__list"
        role="list"
        [attr.aria-labelledby]="
          proofData.twoApplicants
            ? 'applicant1-title-' + proofData.id
            : 'title-proof-' + proofData.id
        "
      >
        <ng-container *ngIf="proofData.templates1">
          <ng-container
            *ngFor="
              let item of proofData.templates1;
              let i = index;
              trackBy: trackByTemplateId
            "
          >
            <li class="list__item" role="listitem">
              <svg-icon
                src="/resultpage/assets/icons/CHECKMARK.svg"
                [svgStyle]="{ 'width.px': 17, 'height.px': 17 }"
                aria-hidden="true"
              />
              <p>{{ item.name }}</p>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </div>
    <div
      class="proof_list_wrapper"
      *ngIf="proofData.templates2?.length || proofData.applicant2HasDAC"
      tabindex="0"
      [attr.aria-labelledby]="'applicant2-title-' + proofData.id"
      #focusableContent
    >
      <p
        *ngIf="proofData.twoApplicants"
        class="proof_list-applicant"
        [attr.id]="'applicant2-title-' + proofData.id"
      >
        {{ proofData.applicant2FullName }}
      </p>
      <ul
        class="proof__list"
        role="list"
        [attr.aria-labelledby]="'applicant2-title-' + proofData.id"
      >
        <ng-container *ngIf="proofData.templates2">
          <ng-container
            *ngFor="
              let item of proofData.templates2;
              let i = index;
              trackBy: trackByTemplateId
            "
          >
            <li class="list__item" role="listitem">
              <svg-icon
                src="/resultpage/assets/icons/CHECKMARK.svg"
                [svgStyle]="{ 'width.px': 17, 'height.px': 17 }"
                aria-hidden="true"
              />
              <p>{{ item.name }}</p>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </div>
  </div>
  <div
    class="proof_list_wrapper proof_list_wrapper-one-applicant"
    *ngIf="proofData.bankProduct.bankDetails.bankGateway === 'ANADIBANK'"
    tabindex="0"
    [attr.aria-labelledby]="'title-proof-' + proofData.id"
    #focusableContent
  >
    <ul
      class="proof__list"
      role="list"
      [attr.aria-labelledby]="'title-proof-' + proofData.id"
    >
      <li class="list__item" role="listitem" *ngIf="!proofData.applicant1HasDAC">
        <svg-icon
          src="/resultpage/assets/icons/CHECKMARK.svg"
          [svgStyle]="{ 'width.px': 17, 'height.px': 17 }"
          aria-hidden="true"
        />
        <p>verbundenes Bankkonto</p>
      </li>
      <li class="list__item" role="listitem">
        <svg-icon
          src="/resultpage/assets/icons/CHECKMARK.svg"
          [svgStyle]="{ 'width.px': 17, 'height.px': 17 }"
          aria-hidden="true"
        />
        <p>
          Lichtbildausweis (Reisepass, Personalausweis oder österreichischer
          Führerschein im Scheckkartenformat)
        </p>
      </li>
    </ul>
  </div>
</div>
